import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UxComponent } from './ux.component';
import { DevModeGuard } from './guards/dev.guard';

const uxRoutes: Routes = [
  {
    path: '',
    canActivate: [DevModeGuard],
    component: UxComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(uxRoutes)],
  exports: [RouterModule],
  providers: []
})
export class UXRoutingModule {
}
